import Text from '@redbubble/design-system/src/Text';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import { ToastWrapper } from '../ToastWrapper/ToastWrapper';

export const messages = defineMessages({
  linkCopied: {
    defaultMessage: 'Link copied!',
  },
});

export const LinkCopiedToast: React.FC = () => {
  const intl = useIntl();

  return (
    <ToastWrapper>
      <Text type="body">{intl.formatMessage(messages.linkCopied)}</Text>
    </ToastWrapper>
  );
};
